import VoucherInputField from "./index";

export default function VoucherInputFieldExamples() {
  return (
    <VoucherInputField
      onVoucherCodeChange={() => console.log("voucher input changed")}
    />
  );
}
